



































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import Footer from "@/components/Footer.vue";
import StripeApi from "@/services/StripeApi";
import CustomerForm from "@/components/forms/CustomerForm.vue";
import PaymentForm from "@/components/forms/PaymentForm.vue";
import CouponForm from "@/components/forms/CouponForm.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";
import AuthModule from "@/store/auth";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import { UpdateSubscription } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    CustomerForm,
    PaymentForm,
    CouponForm,
    CTooltip,
    Footer,
  },
})
export default class URegisterPaymentEdit extends CheckUserLogin {
  // 入力フォーム初期値
  private form: UpdateSubscription = { subId: "", endOfPeriodCancel: true };

  private cusId = "";

  // プレミア会員解約ダイアログ
  private isCancelDialog = false;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private async mounted() {
    if (this.me?.cusId) {
      this.cusId = this.me.cusId;
    } else {
      this.$router.push("UDashboard");
    }
  }

  // プレミア会員解約
  private async cancel() {
    try {
      if (this.cusId) {
        // subIdの取得
        const subscriptionRes = await StripeApi.instance.getSubscriptionByCusId(this.cusId);
        const subscription = subscriptionRes.data.data;

        this.form.subId = subscription[0].id;
        // サブスクリプションをキャンセル
        await StripeApi.instance.updateSubscription(this.form);
        this.isCancelDialog = false;
        this.$router.push({ name: "URegisterPayment" });
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
